<section>
  <div class="card">
    <div class="card-header bg-body">
      <h2 class="mb-3" tabindex="0" nessAutoFocus>View result details</h2>
      <div class="d-flex flex-wrap">
        <ng-container *removeIfUnauthorizedResult="canEdit">
          <button *ngIf="canApprove()" type="button" class="btn btn-active me-2 mb-2" (click)="approveResult()">Approve or Reject</button>
          <button class="btn btn-active mb-2 me-lg-auto" (click)="editResult()">Edit result</button>
        </ng-container>
        <button type="button" class="btn btn-secondary d-print-none mb-2" title="Download PDF file" (click)="onClickDownloadResult()"><i class="fas fa-print" aria-hidden="true"></i> Download printable view</button>
      </div>
    </div>
    <div class="card-body">
      <error-status *ngIf="displayErrorStatus" [messageTemplate]="errorMessage"></error-status>
      <ng-container *ngIf="resultData$ | async as resultData;else loadingresult">
        <ng-container *ngIf="resultData.ENESS_SuccessStory">
          <div class="row gy-2 gx-3 align-items-start m-2">
            <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Status:</div>
            <div class="col-lg-9 col-md-8">{{ resultData.ENESS_SuccessStory?.CurrentSuccessStoryStatus?.ENESS_REF_SuccessStoriesStatuses?.SuccessStoriesStatus }}</div>
            <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Created By:</div>
            <div class="col-lg-9 col-md-8">{{ resultData.ENESS_SuccessStory.CreatedByUser.FirstName }} {{ resultData.ENESS_SuccessStory.CreatedByUser.LastName }}</div>
            <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Field Division:</div>
            <div class="col-lg-9 col-md-8">{{ resultData.ENESS_SuccessStory.CGICCode | CGICCodeToFD | async}}</div>
            <div class="col-lg-3 col-md-4 text-xs-start text-md-end">ATF CGIC Supervisor:</div>
            <div class="col-lg-9 col-md-8">{{ resultData.ENESS_SuccessStory.CGICSupervisor?.FirstName }} {{ resultData.ENESS_SuccessStory.CGICSupervisor?.LastName }}</div>
            <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Alternate Results Approver:</div>
            <div class="col-lg-9 col-md-8">{{ resultData.ENESS_SuccessStory.AlternateCGICApprover?.FirstName }} {{ resultData.ENESS_SuccessStory.AlternateCGICApprover?.LastName }} <ng-container *ngIf="resultData.ENESS_SuccessStory.AlternateCGICApprover">({{ resultData.ENESS_SuccessStory.AlternateCGICApprover?.Email }})</ng-container></div>
            <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Results Tracking #:</div>
            <div class="col-lg-9 col-md-8">{{ resultData.ENESS_SuccessStory.InvestigativeTrackingNumber }}</div>
            <div class="col-lg-3 col-md-4 text-xs-start text-md-end">NIBIN/CGI Contributed To:</div>
            <div class="col-lg-9 col-md-8">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let sFactors of resultData.ENESS_SuccessStory.ENESS_XREF_SuccessStoriesFactors">{{ sFactors.ENESS_REF_SuccessStoriesFactors.SuccessStoryFactor }}<span *ngIf="resultData.ENESS_SuccessStory.NumberOfFirearmsRecovered">: {{resultData.ENESS_SuccessStory.NumberOfFirearmsRecovered}}</span></li>
              </ul>
            </div>
            <div class="col-lg-3 col-md-4 text-xs-start text-md-end"> ATF Assets/Systems:</div>
            <div class="col-lg-9 col-md-8">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let sFactors of resultData.ENESS_SuccessStory.ENESS_XREF_SuccessStoriesATFAssets">{{ sFactors.ENESS_REF_SuccessStoryATFAssets.ATFAsset }}</li>
              </ul>
            </div>
            <div class="col-lg-3 col-md-4 text-xs-start text-md-end"># of Shootings Linked to Arrestees/Defendants:</div>
            <div class="col-lg-9 col-md-8">{{ resultData.ENESS_SuccessStory.NumberOfShootings }}</div>
            <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Firearm(s) Recovered:</div>
            <div class="col-lg-9 col-md-8">{{ resultData.ENESS_SuccessStory.NumberOfFirearmsRecovered }}</div>
            <div class="col-lg-3 col-md-4 text-xs-start text-md-end">IR Tracking Numbers:</div>
            <div class="col-lg-9 col-md-8 table-responsive">
              <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
                <thead>
                  <tr>
                    <th scope="col">IR Tracking Number</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngIf="resultData.ENESS_SuccessStory.ENESS_XREF_SuccessStoriesCIPs.length == 0;else irtnrows"><tr><td>No IR tracking numbers found.</td></tr></ng-container>
                  <ng-template #irtnrows>
                    <tr *ngFor="let irNum of resultData.ENESS_SuccessStory.ENESS_XREF_SuccessStoriesCIPs">
                      <td>{{ irNum.CIPTrackingID }}</td>
                    </tr>
                  </ng-template>
                </tbody>
              </table>
            </div>
            <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Primary Crime Gun ID(s):</div>
            <div class="col-lg-9 col=md-8 table-responsive">
              <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
                <thead>
                  <tr>
                    <th scope="col">Crime Gun ID(s)</th>
                    <th scope="col">Legacy Gun ID(s)</th>
                    <th scope="col"># of Linked Shootings</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngIf="hasPrimaryCrimeGunID;else pcgrows"><tr><td colspan="3">No primary crime gun ID(s) found.</td></tr></ng-container>
                  <ng-template #pcgrows>
                    <tr *ngFor="let cgn of ( resultData.ENESS_SuccessStory.ENESS_XREF_SuccessStoriesCrimeGuns | filterPrimary: true )">
                      <th scope="row">
                        <ng-container *ngIf="!cgn.IsRemovedCrimeGun && cgn.HasPermission; else nocglink">
                          <a (click)="openRelatedCrimeGun($event, cgn.CrimeGunNumberID)">{{ cgn.CrimeGunNumber }}</a>
                        </ng-container>
                        <ng-template #nocglink>
                          <span *ngIf="cgn.IsRemovedCrimeGun" pTooltip="CGID was deleted">{{ cgn.CrimeGunNumber }}</span>
                          <span *ngIf="!cgn.IsRemovedCrimeGun && !cgn.HasPermission" pTooltip="Outside Agency CGID">{{ cgn.CrimeGunNumber }}</span>
                        </ng-template>
                      </th>
                      <td>{{ cgn.LegacyATFGunNumber }}</td>
                      <td>{{ cgn.NumberOfLinkedShootings }}</td>
                    </tr>
                  </ng-template>
                </tbody>
              </table>
            </div>
            <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Linked Crime Gun ID(s):</div>
            <div class="col-lg-9 col-md-8 table-responsive">
              <table class="temp-bs table table-sm table-striped table-bordered col-md-6" aria-describedby="DataTable">
                <thead>
                  <tr>
                    <th scope="col">Crime Gun ID(s)</th>
                    <th scope="col">Legacy Gun ID(s)</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngIf="hasLinkedCrimeGunID;else lcgrows"><tr><td colspan="2">No linked crime gun ID(s) found.</td></tr></ng-container>
                  <ng-template #lcgrows>
                    <tr *ngFor="let cgn of ( resultData.ENESS_SuccessStory.ENESS_XREF_SuccessStoriesCrimeGuns | filterPrimary: false )">
                      <th scope="row">
                        <ng-container *ngIf="!cgn.IsRemovedCrimeGun; else nocglink">
                          <a (click)="openRelatedCrimeGun($event, cgn.CrimeGunNumberID)">{{ cgn.CrimeGunNumber }}</a>
                        </ng-container>
                        <ng-template #nocglink>
                          <span pTooltip="CGID was deleted">{{ cgn.CrimeGunNumber }}</span>
                        </ng-template>
                      </th>
                      <td>{{ cgn.LegacyATFGunNumber }}</td>
                    </tr>
                  </ng-template>
                </tbody>
              </table>
            </div>
            <div class="col-lg-3 col-md-4 text-xs-start text-md-end">RMS Event(s):</div>
            <div class="col-lg-9 col-md-8 table-responsive">
              <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
                <thead>
                  <tr>
                    <th scope="col">State</th>
                    <th scope="col">Agency</th>
                    <th scope="col">LE Case #</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngIf="resultData.ENESS_SuccessStory.ENESS_XREF_SuccessStoriesLECaseNumbers.length == 0;else lcnrows"><tr><td colspan="3">No LE case #s found.</td></tr></ng-container>
                  <ng-template #lcnrows>
                    <tr *ngFor="let lcn of resultData.ENESS_SuccessStory.ENESS_XREF_SuccessStoriesLECaseNumbers">
                      <th scope="row">{{lcn.ENESS_REF_State.StateAbbreviation}}</th>
                      <td>{{ lcn.ENESS_REF_Agency.AgencyName}}</td>
                      <td>{{ lcn.LECaseNumber }}</td>
                    </tr>
                  </ng-template>
                </tbody>
              </table>
            </div>
            <div class="col-lg-3 col-md-4 text-xs-start text-md-end"> Are these results documented in an ATF NFORCE case?</div>
            <div class="col-lg-9 col-md-8">{{ resultData.ENESS_SuccessStory.ENESS_REF_SuccessStoryDefendantHasNFORCECaseNumber?.HasNFORCECaseNumberValue }}</div>
            <div class="col-lg-3 col-md-4 text-xs-start text-md-end" *ngIf="resultData.ENESS_SuccessStory.ENESS_REF_SuccessStoryDefendantHasNFORCECaseNumber?.HasNFORCECaseNumberValue == 'Yes'"> NFORCE Case #:</div>
            <div class="col-lg-9 col-md-8" *ngIf="resultData.ENESS_SuccessStory.ENESS_REF_SuccessStoryDefendantHasNFORCECaseNumber?.HasNFORCECaseNumberValue == 'Yes'">{{ resultData.ENESS_SuccessStory.NFORCECaseNumber }}</div>
            <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Defendant(s):</div>
            <div class="col-lg-9 col-md-8 table-responsive">
              <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
                <thead>
                  <tr>
                    <th scope="col">Last Name</th>
                    <th scope="col">First Name</th>
                    <th scope="col">Adjudication Status</th>
                    <th scope="col">Prosecution Type</th>
                    <th scope="col">Arrest Date</th>
                    <th scope="col">Conviction Date </th>
                    <th scope="col">Sentence Date</th>
                    <th scope="col">Sentence (In Months)</th>
                    <th scope="col"># of Shootings Charged/Indicted</th>
                    <th scope="col">Charge(s)</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngIf="resultData.ENESS_SuccessStory.ENESS_XREF_SuccessStoryDefendant.length == 0;else dfdntrows"><tr><td colspan="10">No defendant found.</td></tr></ng-container>
                  <ng-template #dfdntrows>
                    <tr *ngFor="let defendant of resultData.ENESS_SuccessStory.ENESS_XREF_SuccessStoryDefendant">
                      <td>{{ defendant.ENESS_Person?.LastName }}</td>
                      <td>{{ defendant.ENESS_Person?.FirstName }}</td>
                      <td>{{ defendant.ENESS_REF_SuccessStoryAdjudicationStatuses?.SuccessStoryAdjudicationStatus }}</td>
                      <td>{{ defendant.ENESS_REF_SuccessStoryProsecutionTypes?.SuccessStoryProsecutionType }}</td>
                      <td>{{ defendant.ArrestDate | date:"MM/dd/yyyy" }}</td>
                      <td>{{ defendant.ConvictionDate | date:"MM/dd/yyyy" }}</td>
                      <td>{{ defendant.SentencingDate | date:"MM/dd/yyyy" }}</td>
                      <td>{{ defendant.SentenceInMonths }}</td>
                      <td>{{ defendant.NumberOfShootingsChargedOrIndicted }}</td>
                      <td class="text-break">{{ defendant.Charges }}</td>
                    </tr>
                  </ng-template>
                </tbody>
              </table>
            </div>
            <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Narrative: </div>
            <div class="col-lg-9 col-md-8">{{ resultData.ENESS_SuccessStory.Narrative }}</div>
            <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Attachments:</div>
            <div class="col-lg-9 col-md-8 table-responsive">
              <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
                <thead>
                  <tr>
                    <th scope="col">Uploaded Attachments</th>
                    <th scope="col" class="text-nowrap">Created By Email</th>
                    <th scope="col" class="text-nowrap">Created On</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngIf="resultData.ENESS_SuccessStory.ENESS_XREF_SuccessStoriesAttachments.length < 1;else attrows"><tr><td colspan="4">No attachment found.</td></tr></ng-container>
                  <ng-template #attrows>
                    <tr *ngFor="let fn of resultData.ENESS_SuccessStory.ENESS_XREF_SuccessStoriesAttachments">
                      <td><button type="button" class="btn btn-link" aria-label="Download attachment file" (click)="onClickDownload(fn.ENESS_SuccessStoryAttachments)">{{fn.ENESS_SuccessStoryAttachments?.FileName}}</button></td>
                      <td>{{ fn.ENESS_SuccessStoryAttachments?.CreatedBy }}</td>
                      <td>{{ fn.ENESS_SuccessStoryAttachments?.CreatedOn?.toString().replace('/Date(','').replace(')/','') | date:"MM/dd/yyyy" }}</td>
                    </tr>
                  </ng-template>
                </tbody>
              </table>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <ng-template #loadingresult><div class="p-3">Loading result details...</div></ng-template>
    </div>
  </div>
</section>
